import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { WIKIS_TUTORIAIS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_tutoriais = (data) => {
    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            let target = data ? "C" : "P";

            return axios.get(`${Config.API_BASE_URL}/KnowledgeBase?scope=Videos`, config)
                .then(response => {

                    const videos = response.data.filter(i => i.scope == "Videos" && i.target == target);

                    dispatch({
                        type: WIKIS_TUTORIAIS_GET,
                        payload: {
                            videos: videos,
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    });
                })
                .catch(error => {
                    dispatch({
                        type: WIKIS_TUTORIAIS_GET,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })
                });

        }).catch(error => {
            // dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_tutoriais;